export const TEXTS = {
  count: 'Résultats de {from} à {to} | Nombre de résultats : {count}',
  filter: 'Filtrer : ',
  filterPlaceholder: 'Rechercher',
  page: 'Page : ',
  noResults: 'Aucun résultat',
  filterBy: '',
  loading: 'Loading...',
  defaultOption: '',
  columns: 'Filtrer par colonne',
};
export const RESULTS_PER_PAGE = 30;
export const PER_PAGE_VALUE = [];



// WEBPACK FOOTER //
// ./src/configuration/clientTableConf.js